import React from "react";
import { Button, Icon, Result } from "antd";
import { useTranslation } from "react-i18next";

const CampaignCreatingCard = ({ campaign, mode, history }) => {
  const { t } = useTranslation();
  const isProposal = mode === "proposal";

  return (
    <div className="campaignDetail__card">
      <h1 className="campaignDetail__title">{campaign.name}</h1>
      <p className="campaignDetail__subtitle">
        {campaign.smart_campaign
          ? t("Programmatic campaign")
          : t("Traditional campaign")}
      </p>

      <h3 className="campaignDetail__section-title">{t("Campaign status")}</h3>
      <div className="campaignDetail__creating" role="status" aria-live="polite">
        <Result
          icon={<Icon type="loading" />}
          title={isProposal ? t("Creating your proposal") : t("Creating your campaign")}
          subTitle={
            <>
              {t("Due to the number of screens, this may take a few minutes.")}{" "}
              {t("We will send you an email when it is ready.")}
              <br />
              {t("You can keep browsing the app.")}
            </>
          }
          extra={
            <Button
              type="primary"
              className="campaignDetail__creating-button"
              onClick={() => history && history.push(isProposal ? "/proposals" : "/campaigns")}
            >
              {isProposal ? t("Go to my proposals") : t("Go to my campaigns")}
              <Icon type="arrow-right" />
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default CampaignCreatingCard;
